<template>
  <div>
    <div class="w-full pl-2">
        <b class="p-1 block">{{ title }}</b>
        <TheRadio :error="error" :label="radioLabel1" :value="true" v-model="inputValue" />
        <TheRadio :error="error" :label="radioLabel2" :value="false" v-model="inputValue" />
    </div>
    <div class="text-red-400 text-xs p-2" v-if="error">
      <b>{{ error }}</b>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'

const emit = defineEmits(['update:modelValue'])

const props = defineProps({
    modelValue: {
        type: [Boolean, String],
        default: false,
    },
    error: String,
    title: String,
    radioLabel1: String,
    radioLabel2: String
})

const inputValue = ref(props.modelValue)

watch(() => props.modelValue, (val) => {
  inputValue.value = val
})

watch(inputValue, (val) => {
  emit('update:modelValue', val)
})

</script>
